export const projectFieldHelp = {
  name: {
    description: 'Nome do projeto como a equipe e o cliente o reconhecem.',
    example: 'Implantação bTalk — onda 1',
  },
  code: {
    description: 'Identificador interno do projeto neste contrato. Opcional se ainda não houver código oficial.',
    example: 'prj-btalk-onda-1',
  },
  status: {
    description: 'Situação do projeto no ciclo de vida (rascunho, ativo, em espera, concluído ou cancelado).',
    example: 'Ativo',
  },
  lifecycleModel: {
    description: 'Como o trabalho será conduzido: cascata, iterativo, incremental, ágil, híbrido ou customizado.',
    example: 'Híbrido',
  },
  description: {
    description: 'Resumo do objetivo do projeto e do resultado esperado.',
    example: 'Colocar a plataforma em produção com o primeiro canal de atendimento',
  },
  scope: {
    description: 'O que entra e o que fica fora desta entrega, para evitar escopo implícito.',
    example: 'Incluso: chat e base de conhecimento. Fora: app interno do cliente',
  },
  workProducts: {
    description: 'Entregáveis concretos que o projeto deve produzir.',
    example: 'Ambiente produtivo, playbooks de atendimento e treinamento da operação',
  },
  sizeEstimate: {
    description: 'Tamanho estimado do trabalho, na unidade escolhida ao lado.',
    example: '5',
  },
  sizeUnit: {
    description: 'Unidade do tamanho (pontos, sprints, pacotes, etc.).',
    example: 'sprints',
  },
  effortHours: {
    description: 'Esforço estimado em horas da equipe para concluir o projeto.',
    example: '320',
  },
  costEstimate: {
    description: 'Custo interno estimado de execução, em reais.',
    example: '48000',
  },
  budget: {
    description: 'Orçamento aprovado com o cliente ou internamente para este projeto.',
    example: '52000',
  },
  plannedStart: {
    description: 'Data planejada de início das atividades.',
    example: '01/09/2026',
  },
  plannedEnd: {
    description: 'Data planejada de encerramento das entregas.',
    example: '30/11/2026',
  },
  lifecyclePhases: {
    description: 'Fases previstas no ciclo escolhido, em ordem.',
    example: 'Kickoff, configuração, homologação, go-live',
  },
  resourcesPlan: {
    description: 'Pessoas, ambientes e ferramentas necessárias para executar o projeto.',
    example: '1 CS, 1 implementação e ambiente de homologação do cliente',
  },
  feasibility: {
    description: 'Avaliação se o prazo, o orçamento e as premissas são realistas.',
    example: 'Viável com acesso ao canal de mensagens na primeira semana',
  },
  stakeholderCommitment: {
    description: 'Marque se os interessados já confirmaram patrocínio, prazos e disponibilidade.',
    example: 'marcado após a ata de kickoff assinada',
  },
  monitoring: {
    description: 'Como o andamento será acompanhado (ritmo, indicadores, ritos).',
    example: 'Status semanal na sexta e burndown das pendências de go-live',
  },
  notes: {
    description: 'Anotações internas que não cabem nos demais campos.',
    example: 'Cliente pede janela de go-live fora do horário de pico',
  },
} as const;
